import { Link, useLocation, useNavigate } from "react-router-dom";
import { CONTACT_EMAIL, NAV_LINKS, SOCIALS } from "@/config/site";
import { scrollToId } from "@/lib/scroll";
import { Logo } from "./Logo";
import { StoreBadges } from "./StoreBadges";

const linkCls = "text-[15px] text-pa-muted transition-colors duration-300 hover:text-pa-ink";
const Heading = ({ children }) => <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-pa-dim">{children}</p>;

export const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = (id) => (pathname === "/" ? scrollToId(id) : navigate(`/#${id}`));

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-pa-black">
      <div className="mx-auto max-w-[1400px] px-5 pt-20 sm:px-8 lg:px-12">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo testId="footer-logo" />
            <p className="mt-5 max-w-xs text-pa-muted">Build your music career beyond the stream.</p>
          </div>
          <nav aria-label="Footer" className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-5">
            <div className="space-y-3">
              <Heading>Explore</Heading>
              {NAV_LINKS.map((l) => (
                <button key={l.id} onClick={() => go(l.id)} data-testid={`footer-link-${l.id}`} className={`block ${linkCls}`}>{l.label}</button>
              ))}
            </div>
            <div className="space-y-3">
              <Heading>Company</Heading>
              <Link to="/privacy" data-testid="footer-link-privacy" className={`block ${linkCls}`}>Privacy</Link>
              <Link to="/terms" data-testid="footer-link-terms" className={`block ${linkCls}`}>Terms</Link>
              <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-link-contact" className={`block ${linkCls}`}>Contact</a>
            </div>
            <div className="space-y-3">
              <Heading>Social</Heading>
              {SOCIALS.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${s.label.toLowerCase()}`} className={`block ${linkCls}`}>
                  {s.label} ↗
                </a>
              ))}
            </div>
          </nav>
          <div className="lg:col-span-3">
            <Heading>Get the app</Heading>
            <StoreBadges idPrefix="footer-store-badge" source="footer" className="mt-4 flex-col" />
          </div>
        </div>
        <p className="mt-20 select-none font-display text-[22vw] uppercase leading-[0.78] text-white/[0.05] lg:text-[19vw]" aria-hidden="true">Pitchally</p>
        <div className="flex flex-col gap-3 border-t border-white/10 py-6 text-xs text-pa-dim sm:flex-row sm:justify-between">
          <p>© {new Date().getFullYear()} Pitchally. A product of Pitchclerk Music Group.</p>
          <p>Made for artists everywhere.</p>
        </div>
      </div>
    </footer>
  );
};
